export const validateUrl = (url: string | undefined): string | undefined => {
  if (typeof url !== 'string') {
    return url
  }

  return url.endsWith('/') ? url : url + '/'
}
